import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

interface Props {
  analyticsDisabledForAdmin?: boolean;
  discrepancyInCompletion?: boolean;
  title?: string;
  value: number | React.ReactNode;
}

const ProgressLabel = ({
  analyticsDisabledForAdmin,
  discrepancyInCompletion,
  title,
  value
}: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div
      className={`label ${title ? 'label-with-title' : ''}`}
      {...(discrepancyInCompletion ? {} : {})}
    >
      {title ? (
        <div className="title">
          {title}

          {analyticsDisabledForAdmin ? (
            <span
              className="analytics-disabled"
              data-tooltip={messages.tasksIgnoredInfo}
            >
              <Icon icon="exclamation-triangle" />
            </span>
          ) : null}
        </div>
      ) : null}

      <span
        className="value"
        {...(discrepancyInCompletion
          ? {
              'aria-label': messages.tasksUsersCompletionDiscrepancy,
              'data-tooltip': messages.tasksUsersCompletionDiscrepancy
            }
          : {})}
      >
        {value}

        {discrepancyInCompletion ? (
          <span className="discrepancy">
            <Icon icon="asterisk" />
          </span>
        ) : null}

        {analyticsDisabledForAdmin && !title ? (
          <span
            className="analytics-disabled"
            data-tooltip={messages.tasksIgnoredInfo}
          >
            <Icon icon="exclamation-triangle" />
          </span>
        ) : null}
      </span>

      <style jsx>{`
        .label-with-title {
          align-items: center;
          display: flex;
          justify-content: space-between;
          margin-bottom: 3px;
        }
        .title {
          color: ${theme.textColorLight};
          font-size: 1.4rem;
        }
        .analytics-disabled {
          font-size: 1rem;
          color: ${theme.textColorLighter};
          margin-left: 5px;
        }
        .discrepancy {
          font-size: 0.6rem;
          padding: 0 2px;
          vertical-align: top;
        }
      `}</style>
    </div>
  );
};

export default ProgressLabel;
